import z, { object } from 'zod';

import { withIsEnabled } from '../utils/with-is-enabled';

export const CustomDataInputSchema = z
  .string()
  .optional()
  .refine((value) => {
    if (!value) {
      return true;
    }

    try {
      const parsedValue = JSON.parse(value);
      return typeof parsedValue === 'object' && parsedValue !== null;
    } catch {
      return false;
    }
  }, 'Invalid JSON format');

const CustomDataEnabledSchema = object({
  data: CustomDataInputSchema,
});

const CustomDataDisabledSchema = object({
  data: z.string().optional(),
}).passthrough();

export const CustomDataSchema = withIsEnabled(
  CustomDataEnabledSchema,
  CustomDataDisabledSchema,
).optional();

export type CustomDataFormValues = z.infer<typeof CustomDataSchema>;
